import { getFreeOrderCTAPending, useAppSelector } from 'store';
import { useCheckout } from 'frontastic/hooks/useCheckout';
import { PlaceOrderButton } from './place-order-button';
import { CheckoutFormProps } from './types';

export const FreeOrderCheckoutForm = (props: CheckoutFormProps) => {
  const isFreeOrderCTAPending = useAppSelector(getFreeOrderCTAPending);
  const { placeFreeOrder } = useCheckout();
  const handleSubmit = () => {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    placeFreeOrder({ ...props });
  };

  return (
    <PlaceOrderButton
      isCTAPending={isFreeOrderCTAPending}
      onClick={handleSubmit}
    />
  );
};
